import { AlertTriangle } from "lucide-react";

export const UnsavedDecisionDialog = ({ prompt = {}, busy, onStay, onDiscard, onSave, testIds }) => (
  <div className="fixed inset-0 bg-black/40 z-[90] flex items-center justify-center px-4"
       role="dialog" aria-modal="true" aria-label={prompt.title || "Modifiche non salvate"}
       data-testid={testIds.modal}>
    <div className="bg-white rounded-sm shadow-xl w-full max-w-lg p-6">
      <div className="flex items-start gap-3 mb-3">
        <div className="w-9 h-9 rounded-full bg-[#FBF3E7] flex items-center justify-center shrink-0">
          <AlertTriangle className="w-4 h-4 text-[#A07A2A]" strokeWidth={2} />
        </div>
        <div>
          <h3 className="font-serif text-2xl leading-tight">{prompt.title || "Modifiche non salvate"}</h3>
          <p className="text-sm text-[#707070] mt-1" data-testid={testIds.description}>
            {prompt.description || "Hai delle modifiche non salvate su questa pagina. Vuoi salvarle prima di uscire?"}
          </p>
          {prompt.error && <p className="text-sm text-[#8C3A3A] mt-2" role="alert" data-testid={testIds.error}>{prompt.error}</p>}
        </div>
      </div>
      <div className="flex flex-col sm:flex-row justify-end gap-2 mt-5">
        <button onClick={onStay} disabled={busy} className="btn-ghost order-3 sm:order-1 sm:whitespace-nowrap"
                data-testid={testIds.stay}>
          {prompt.stayLabel || "Annulla"}
        </button>
        <button onClick={onDiscard} disabled={busy} className="btn-ghost text-[#8C3A3A] order-2 sm:whitespace-nowrap"
                data-testid={testIds.discard}>
          {prompt.discardLabel || "Esci senza salvare"}
        </button>
        <button onClick={onSave} disabled={busy}
                className={`btn-primary order-1 sm:order-3 sm:whitespace-nowrap ${busy ? "opacity-50 cursor-not-allowed" : ""}`}
                data-testid={testIds.save}>
          {busy ? "Salvataggio..." : (prompt.saveLabel || "Salva ed esci")}
        </button>
      </div>
    </div>
  </div>
);